import { useEffect, useState } from "react";
import useQuerySearch from "./useQuerySearch";

export interface IWithQuerySelector<T> {
  getSearch?: (query: string, page?: number, pageSize?: number) => Promise<any>;
  timeout?: number;
  pageSize?: number;
  addMoreResult?: (prev: any, next: any) => any;
  extractLastPage?: (result: T) => number;
}

export interface ViewQuerySelectorProps {
  result: any;
  isLoading: boolean;
  errorMessage: string | null;
  onClickItem: (item: any) => void;
  setValueQuery: (value: string) => void;
  valueQuery?: string | null;

}

export default function useQuerySelector<T>(config: IWithQuerySelector<T>) {
  const [result, setResult] = useState<T | null>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [page, setPageRaw] = useState<number>(1);
  const [lastPage, setLastPage] = useState<number | null>(null);

  const sendQuery = (query: string | null) => {
    if (config.getSearch) {
      setIsLoading(true);
      setError(null);
      setPageRaw(1);
      setLastPage(null);
      config
        .getSearch(query || "", config.pageSize? 1 : undefined, config.pageSize)
        .then((res) => {
          setResult(res);

          if (config.extractLastPage) {
            setLastPage(config.extractLastPage(res));
          }
          setIsLoading(false);
        })
        .catch((e) => {
          setError(e);
          setIsLoading(false);
        });
    }
  };
  const { setQuery, valueQuery } = useQuerySearch({
    timeout: config.timeout,
    setIsLoading: setIsLoading,
    sendQuery: sendQuery,
  });

  const setPage = (page: number) => {
     setIsLoadingMore(true);
     config.getSearch && config.getSearch(valueQuery || "", page, config.pageSize).then((res) => {
        setResult(config.addMoreResult ? config.addMoreResult(result, res) : res);
        setIsLoadingMore(false);
        setPageRaw(page);
     }).catch((e) => {
        setError(e);
        setIsLoadingMore(false);
     });
  }


  useEffect(() => {
    sendQuery("");
  }, []); // eslint-disable-line

  return {
    resultFound: result,
    isLoading,
    isLoadingMore,

    error,

    setValueQuery: setQuery,
    valueQuery,
    page,
    setPage,
    lastPage, 
    sendQuery,
  };
}
